import { model as i18n } from '!/i18n'
import { combine } from 'effector'

export const $signInFormTranslations = combine(i18n.$t, ({ t }) => ({
  title: t('sign_in'),
  redirectQuestion: t('do_not_have_account'),
  redirectLink: t('sign_up'),
}))
